
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("dNA1f", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.80783181.js.map
